import {SET_SERVER_ERROR_STATUS} from '../actionTypes';

export const setServerErrorStatus = (serverErrorStatus: string | number | null) => ({
    type: SET_SERVER_ERROR_STATUS,
    serverErrorStatus
});
